import { render, staticRenderFns } from "./PrivacyNotice.vue?vue&type=template&id=a6253494"
import script from "./PrivacyNotice.vue?vue&type=script&setup=true&lang=ts"
export * from "./PrivacyNotice.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PrivacyNotice.vue?vue&type=style&index=0&id=a6253494&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports